import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import config from '../../../../../config'
import { useTranslation } from '@/hooks/useTranslation'

export const WordPressSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="wordpress" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.wordpress.title')}
			</h2>

			<Card className="mb-6 shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle>{t('docs.wordpress.method1.title')}</CardTitle>
				</CardHeader>
				<CardContent>
					<ol className="list-decimal pl-5 space-y-3 text-gray-600 dark:text-gray-400">
						<li>
							{t('docs.wordpress.method1.step1.prefix')}{' '}
							<a
								href="https://wordpress.org/plugins/insert-headers-and-footers/"
								target="_blank"
								rel="noopener noreferrer"
								className="text-primary hover:underline font-medium">
								{t('docs.wordpress.method1.step1.plugin1')}
							</a>{' '}
							{t('docs.wordpress.method1.step1.or')}{' '}
							<a
								href="https://wordpress.org/plugins/code-snippets/"
								target="_blank"
								rel="noopener noreferrer"
								className="text-primary hover:underline font-medium">
								{t('docs.wordpress.method1.step1.plugin2')}
							</a>
						</li>
						<li>
							{t('docs.wordpress.method1.step2.prefix')}{' '}
							<strong>{t('docs.wordpress.method1.step2.menuPath')}</strong>{' '}
							{t('docs.wordpress.method1.step2.suffix')}
						</li>
						<li>{t('docs.wordpress.method1.step3')}</li>
						<li>{t('docs.wordpress.method1.step4')}</li>
						<li>
							{t('docs.wordpress.method1.step5.prefix')}{' '}
							{config.appName}{' '}
							{t('docs.wordpress.method1.step5.suffix')}
						</li>
						<li>
							{t('docs.wordpress.method1.step6.prefix')}{' '}
							{config.appName}{' '}
							{t('docs.wordpress.method1.step6.suffix')}
						</li>
					</ol>
					<div className="mt-4">
						<CodeBlock
							language="html"
							copyLabel={t('docs.wordpress.method1.copyLabel')}
							copyMessage={t('docs.wordpress.method1.copyMessage')}
							code={`<script
    defer
    src="https://cdn.feedbask.com/widget.js"
    data-client-key="YOUR_WIDGET_ID"
    data-language="en"
    id="feedbask-widget-script"
></script>`}
						/>
					</div>
					<ol
						className="list-decimal pl-5 space-y-2 text-gray-600 dark:text-gray-400 mt-4"
						start={7}>
						<li>{t('docs.wordpress.method1.step7')}</li>
						<li>
							{t('docs.wordpress.method1.step8')}
						</li>
					</ol>
					<div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-md">
						<p className="text-sm text-blue-800 dark:text-blue-200">
							<strong>{t('docs.wordpress.method1.proTip.label')}</strong>{' '}
							{t('docs.wordpress.method1.proTip.text')}
						</p>
					</div>
				</CardContent>
			</Card>

			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle>{t('docs.wordpress.method2.title')}</CardTitle>
				</CardHeader>
				<CardContent>
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.wordpress.method2.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							functions.php
						</code>{' '}
						{t('docs.wordpress.method2.instruction.middle')}{' '}
						<strong>{t('docs.wordpress.method2.instruction.menuPath')}</strong>
						{t('docs.wordpress.method2.instruction.suffix')}
					</p>
					<CodeBlock
						language="php"
						copyLabel={t('docs.wordpress.method2.copyLabel')}
						copyMessage={t('docs.wordpress.method2.copyMessage')}
						code={`function add_feedbask_widget() {
    ?>
    <script
        defer
        src="https://cdn.feedbask.com/widget.js"
        data-client-key="YOUR_WIDGET_ID"
        data-language="en"
        id="feedbask-widget-script"
    ></script>
    <?php
}
add_action('wp_footer', 'add_feedbask_widget');`}
					/>
				</CardContent>
			</Card>
		</section>
	)
}